import { ListElement } from '@monorepo/shared/componentsV2/dragAndDrop/styled';
import React from 'react';
import styled from 'styled-components';
import { DisplayQueryColumn } from '@monorepo/shared/componentsV2/QueryResultsTable/resultsMapper';
import { TruncatedColumnLabel } from './TruncatedColumnLabel';
import { ViewColumnShowHideButton } from './ViewColumnShowHideButton';
import { StyledListItemLabel } from './styles';

export const StyledUnorderableListElement = styled(ListElement)`
  position: relative;
  width: calc(100% - 0.5rem);

  & .MuiButtonBase-root {
    opacity: 0;
    transition: opacity 0.1s ease-in-out;
  }

  &:focus-within .MuiButtonBase-root,
  &:hover .MuiButtonBase-root {
    opacity: 1;
  }
`;

export function UnorderableColumnListItem({
  column,
  disableShowHideButton,
  toggleColumnVisibility,
  className,
}: {
  column: DisplayQueryColumn;
  disableShowHideButton: boolean;
  toggleColumnVisibility: (column: DisplayQueryColumn) => void;
  className?: string;
}) {
  return (
    <StyledUnorderableListElement key={column.columnName} className={className}>
      <StyledListItemLabel>
        <TruncatedColumnLabel column={column} showIcon>
          <ViewColumnShowHideButton
            column={column}
            disabled={disableShowHideButton}
            onClick={() => {
              toggleColumnVisibility(column);
            }}
          />
        </TruncatedColumnLabel>
      </StyledListItemLabel>
    </StyledUnorderableListElement>
  );
}

export const FilteredColumnListItem = styled(UnorderableColumnListItem)`
  & ${StyledListItemLabel} {
    margin-left: 1.5rem;
  }
`;
